import { Component, effect, OnInit } from "@angular/core";
import { Subject, Subscription } from 'rxjs';
import { NgFor } from "@angular/common";

import { PlanService } from "../../../shared/plan-data.service";
import { FeatureData, Plan } from "../../../shared/models/plan.model";
import { DirectSessionLogicService } from "../../../shared/direct-session-logic.service";
import { PlanData, PageNotes } from "../../../shared/models/config-data.model";

import { FormContactInfoConfirmationComponent } from "./form-contact-confirmation/form-contact-confirmation.component";
import { environment } from "../../../../environments/environment";
import { ItemFormat } from "../../../shared/models/itemFormat.model";

@Component({
    selector: 'app-form-textBox',
    template:`
    <!-- <div class="page-header">Plan Overview</div> -->
    <h3>Review Info</h3>
    <!-- <div>
        <p>{{this.pageDescription}}</p>
    </div> -->
    <h5>Your Plan</h5>
    <!-- <hr> -->
    <div class="d-flex row">
        @for(value of filteredFeaturesData; track value.featRef){
            <div class="feature-block col-sm-6 col-md-4">
    
                <div class="feature-header">{{value.featName}}</div>
    
                @for(item of value.featList; track item){
                    <div class="feature-line">
                        <!-- <img src="assets/Icons/check.svg" alt="checkmark" class="icon-check"> -->
                        <div class="bullet-point"></div>
                        <div class="item-line">{{item}}</div>
                    </div>    
                }
    
            </div>
        }
        <app-form-contact-confirmation></app-form-contact-confirmation>
    </div>
    `,
    styleUrls: ['./form-textBox.component.scss'],
    standalone: true,
    imports: [ FormContactInfoConfirmationComponent ],

})
export class FormTextBoxComponent implements OnInit{

    filteredFeaturesData: FeatureData[] = [];
    pageNotes: PageNotes[] = [];

    pageDescription: string = "";

    
    private unsubscriber = new Subject<void>();
    Features: PlanData[] = [];
    FeatureList: string[] = [];

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        public planService: PlanService
    ){
        this.escapeCheck();

        effect(() => {
            this.initTheseOptions();
        });
        

    }

    get plan(): Plan {
        return this.directSessionLogic.planSelectedSignal();
    }
    get selections(): ItemFormat[] {
        return this.directSessionLogic.cartItemsSignal();
    }
    get featuresData(): FeatureData[] {
        return this.planService.featureViewSignal();
    }


    ngOnInit(){
        this.escapeCheck();
    }

    escapeCheck(){
        if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
            console.log("no plan selected, escaping to top level");
            this.directSessionLogic.escapeToTopLevelSignal();
        }else{
            this.directSessionLogic.completeCurrentPage();
        }
    }
    async initTheseOptions() {

        //add features from the plan data
        let describedFeatures: string[] = [];
        describedFeatures = describedFeatures.concat(this.plan.planFeatures);


        //add features from the items data
        if(this.selections != undefined){
            describedFeatures = describedFeatures.concat(
                this.selections.map(item => item.itemFeatureRef)  
            );
        }

        //add features from the config data            
        this.filteredFeaturesData = this.featuresData.filter( 
            feat => describedFeatures.includes(feat.featRef)
        );



        await this.initConfigData();
    }

    async initConfigData(){
        //gets subtext for the page
        let pageRefId = this.directSessionLogic.getCurrentStepSignal().reference;

        this.pageNotes = environment.PageNotes.filter( note => 
            note.PageRef === pageRefId
        );

        this.pageDescription = this.pageNotes[0]?.PageNote.toString() ?? "";
    }


    getFeatures(){
        if(this.Features != undefined){
            this.initTheseOptions();
        }
        return this.Features;
    }


}